import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OrganisationDto } from '@assetaccountant/api/models/organisation.dto';
import { Register } from '@assetaccountant/core/models/register';
import { PeriodData, PeriodParams } from '@assetaccountant/core/resolvers/period.resolver';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { RouteService } from '@assetaccountant/core/services/route.service';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import { TrackingService } from '@assetaccountant/core/services/tracking.service';
import {
  TypedActivatedRouteSnapshot,
  getChildRoute,
} from '@assetaccountant/core/utils/route-utils';
import { TypedNgbModal, setupModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CreateRegisterModalComponent } from '../../navigation/create-register-modal/create-register-modal.component';

@Component({
  selector: 'app-demo-banner',
  templateUrl: './demo-banner.component.html',
  styleUrls: ['./demo-banner.component.scss'],
  standalone: false,
})
export class DemoBannerComponent implements OnInit {
  isManaged = false;

  currentOrganisation?: OrganisationDto;
  register?: Register;
  registers?: Register[];

  get firstNonDemoRegister() {
    return this.registers?.find(r => !r.isDemo);
  }

  get firstNonDemoRegisterLink() {
    return `${this.routeService.getLinkWithReplacedParameters(['organisations'])}/registers/${
      this.firstNonDemoRegister?.id
    }`;
  }

  get registersLink() {
    return `${this.routeService.getLinkWithReplacedParameters(['organisations'])}/dashboard`;
  }

  get hasOnlyDemoRegister() {
    return this.isDemo && this.registers?.length === 1;
  }

  get hasOneOtherRegister() {
    return this.isDemo && this.registers?.length === 2;
  }

  get isDemo() {
    return this.register?.isDemo;
  }

  constructor(
    private router: Router,
    private organisationService: OrganisationService,
    private subscriptionService: SubscriptionService,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
    private routeService: RouteService,
    private trackingService: TrackingService,
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((e: any): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const { organisation, register } = getChildRoute(
          this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
            PeriodParams,
            PeriodData
          >,
        ).data;

        this.register = register;

        const organisationChanged =
          this.currentOrganisation?.organisationId !==
          organisation?.activeOrganisation.organisationId;
        this.currentOrganisation = organisation?.activeOrganisation;

        if (organisationChanged) {
          this.registers = undefined;
        }

        // only refresh the registers and subscription if the org route has changed
        if (register && !this.registers) {
          forkJoin([
            this.organisationService.listRegisters(),
            this.subscriptionService.getSubscription(),
          ]).subscribe(([{ registers }, subscription]) => {
            this.registers = registers;
            this.isManaged = subscription?.isManaged ?? false;

            if (this.isDemo) {
              this.trackingService.trackEvent('View demo register');
            }
          });
        }
      });
  }

  openCreateRegisterModal() {
    setupModal(this.ngbModal.open(CreateRegisterModalComponent));
  }
}
